export interface Company {
  id: string;
  name: string;
  descriptionKey: string;
  logo: string;
}

export const COMPANIES: Company[] = [
  {
    id: 'feldico',
    name: 'Feldico',
    descriptionKey: 'ember.clients.companies.feldico',
    logo: '/img/logos/feldico-logo.svg',
  },
  {
    id: 'idplans',
    name: 'ID Plans',
    descriptionKey: 'ember.clients.companies.idplans',
    logo: '/img/clients/idplans-logo.png',
  },
  {
    id: 'cloudtomatoes',
    name: 'Cloud Tomatoes',
    descriptionKey: 'ember.clients.companies.cloudtomatoes',
    logo: '/img/logos/cloud-tomatoes.svg',
  },
  {
    id: 'diezpe',
    name: 'Diezpe',
    descriptionKey: 'ember.clients.companies.diezpe',
    logo: '/img/logos/diezpe.svg',
  },
  {
    id: 'gobiernodecordoba',
    name: 'Gobierno de Córdoba',
    descriptionKey: 'ember.clients.companies.gobiernodecordoba',
    logo: '/img/logos/gobierno-de-cordoba.svg',
  },
  {
    id: 'hrmony',
    name: 'Hrmony',
    descriptionKey: 'ember.clients.companies.hrmony',
    logo: '/img/logos/Hrmony.svg',
  },
  {
    id: 'outdoorsy',
    name: 'Outdoorsy',
    descriptionKey: 'ember.clients.companies.outdoorsy',
    logo: '/img/logos/outdoorsy.svg',
  },
  {
    id: 'screensteps',
    name: 'Screensteps',
    descriptionKey: 'ember.clients.companies.screensteps',
    logo: '/img/logos/screensteps.svg',
  },
  {
    id: 'verhaert',
    name: 'Verhaert',
    descriptionKey: 'ember.clients.companies.verhaert',
    logo: '/img/logos/verhaert.svg',
  },
];

